<template>
    <VueSlickCarousel v-if="view.length > 0" v-bind="settings">
        <slot
            name="slide"
            v-for="(slide, index) in view"
            :slide="slide"
            :slideClass="'custom-slide'"
        >
            <div class="custom-slide" :key="index">
                <div class="example-card">{{slide.title}} {{index+1}}</div>
            </div>
        </slot>

        <template #customPaging="page">
            <div class="custom-dot"></div>
        </template>
    </VueSlickCarousel>
    <div v-else class="no-data">
        <h3>Nenhum dado encontrado!</h3>
    </div>
</template>

<script>
export default {
    name: 'dv5-slide',
    props: {
        'view': {
            type: Array,
            default: () => [
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
            ]
        },
        dots: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        arrows: {
            type: Boolean,
            default: false
        },
        infinite: {
            type: Boolean,
            default: true
        },
        speed: {
            type: Number,
            default: 1000
        },
        autoplaySpeed: {
            type: Number,
            default: 4000
        },
        initialSlide: {
            type: Number,
            default: 0
        },
        slidesToShow: {
            type: Number,
            default: 1
        },
        slidesToScroll: {
            type: Number,
            default: 1
        }, // tamanho do salto
        rows: {
            type: Number,
            default: 1
        },
        swipe: {
            type: Boolean,
            default: true
        },
        swipeToSlide: {
            type: Boolean,
            default: true
        },
        responsive: {
            type: Array,
            default: function () {
                return [
                    {
                        "breakpoint": 100000,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            'rows': 1
                        }
                    },
                    {
                        "breakpoint": 1920,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            'rows': 1
                        }
                    },
                    {
                        'breakpoint': 1366,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'rows': 1
                        }
                    },
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            'rows': 1
                        }
                    },
                    {
                        "breakpoint": 768,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            'rows': 1
                        }
                    },
                ]
            }
        }
    },
    data(){
        return {
            settings: {
                dots: this.dots,
                infinite: this.infinite,
                speed: this.speed,
                initialSlide: this.initialSlide,
                slidesToShow: this.slidesToShow,
                slidesToScroll: this.slidesToScroll, // tamanho do salto
                rows: this.rows,
                swipe: this.swipe,
                swipeToSlide: this.swipeToSlide,
                arrows: this.arrows,
                autoplay: this.autoplay,
                autoplaySpeed: this.autoplaySpeed,

                dotsClass: 'custom-dots slick-dots',
                "responsive": this.responsive
            }
        }
    },
    created() {
    },
    methods: {
        showNext() {
            this.$refs.carousel.next()
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../../../scss/extras/variables';
.custom-slide{
    min-height: 150px;

    padding: 5px 5px;
    display: grid!important;
    align-content: stretch;
    justify-content: stretch;
    .example-card{
        background-color: $dv5-color4;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
    }
}

.dv5-shared-carousel{
    padding: 0 70px;
}
.custom-arrow{
    background-color: $dv5-color4;
    height: 46px;
    width: 46px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 22px;
    color: $dv5-color5;

    &::before{
        display: none;
    }

    &:hover{
        cursor: pointer;
        -webkit-box-shadow: 0px 0px 6px 2px rgba($dv5-color1, 0.3);
        box-shadow: 0px 0px 6px 2px rgba($dv5-color1, 0.3);
    }
}

.custom-arrow-prev{
    left: -58px!important;
}
.custom-arrow-next{
    right: -58px!important;
}

.slick-list{
    margin: 0 70px!important;
}

.custom-dot{
    //background-color: $dv5-color6;
    background-color: rgba(128, 128, 128, 0.88);
    width: 15px;
    height: 15px;
    border-radius: 50%;

    font-family: Lato;
    font-size: 10px;
    color: $dv5-color2;
    font-weight: bold;

    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
}
.slick-active{
    .custom-dot{
        background-color: $dv5-color4!important;
        color: $dv5-color4;
    }
}

.no-data{
    font-family: Mulish;
    font-size: 48px;
    font-weight: bold;
    color: $dv5-color2;

    padding: 0 70px;
    text-align: center;
}

</style>

<style lang="scss">
.slick-track { /* IGUALA ALTURA DOS CARDS */
    align-items: stretch!important;
    display: flex!important;
    .slick-slide{
        height: auto!important; // nao remover

        justify-content: stretch!important;
        align-items: stretch!important;
        display: flex!important;
        flex-direction: column!important;
        &>div{
            height: 100%!important;
            width: 100%!important;

            justify-content: stretch!important;
            align-items: stretch!important;
            display: flex!important;
        }
    }
}

*:focus { /* disable outline on click into slide */
    outline: 0;
    outline: none;
}
.dv5-shared-carousel{
    position: static;
    padding-top: 5px
}
.custom-dots{
    margin-top: -6rem;
}
.slick-dots {
    position: relative;
    bottom: -20;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/login-v5/sliders/Slide.vue